import React from 'react';
import SectionHeader from './SectionHeader';
import { Reveal } from './ScrollReveal';

export default function Pricing() {
  return (
    <section id="investition" className="py-32 relative z-10">
      <div className="max-w-[1100px] mx-auto px-8">
        <SectionHeader 
          num="03" 
          eyebrow="Investition & Preisrahmen" 
          title="Transparent.<br/><em class='not-italic italic text-brand-gold'>Kein Versteckspiel.</em>" 
        />
        <div className="grid grid-cols-1 md:grid-cols-2 gap-[1px] bg-brand-border border-2 border-brand-border mb-12 shadow-2xl">
          <Reveal delay={0.1}>
            <div className="bg-brand-dark p-14 h-full">
              <div className="text-[0.7rem] font-bold tracking-[0.2em] uppercase text-brand-muted mb-6">Schritt 1 — Einstieg</div>
              <div className="font-serif text-[1.8rem] font-normal text-brand-white mb-2">Probe-Board-Meeting</div>
              <div className="font-serif text-[3.5rem] font-light text-brand-gold leading-none mb-2">Kostenlos</div>
              <div className="text-[0.85rem] font-bold text-brand-muted2 tracking-widest uppercase mb-8">1 Tag · erstes Board Meeting als Gast</div>
              <div className="text-[1.05rem] text-brand-text leading-relaxed">
                Sie erleben das Format, die Gruppe und die Arbeitsweise — ohne jedes Commitment. Erst danach entscheiden wir gemeinsam, ob eine langfristige Partnerschaft passt.<br/><br/>
                <strong className="text-brand-muted font-bold">Keine Garantie in diesem Schritt.</strong>
              </div>
            </div>
          </Reveal>
          <Reveal delay={0.2}>
            <div className="bg-brand-surface border-t-[6px] border-brand-gold p-14 h-full relative">
              <div className="absolute -top-[1px] left-10 text-[0.7rem] font-black tracking-[0.15em] uppercase bg-brand-gold text-brand-black px-4 py-2 shadow-xl">Mit Garantie</div>
              <div className="text-[0.7rem] font-bold tracking-[0.2em] uppercase text-brand-gold mb-6 mt-2">Schritt 2 — Langfristige Partnerschaft</div>
              <div className="font-serif text-[1.8rem] font-normal text-brand-white mb-2">Executive Sparring</div>
              <div className="font-serif text-[3.5rem] font-light text-brand-gold leading-none mb-2">€ 1.500</div>
              <div className="text-[0.85rem] font-bold text-brand-muted2 tracking-widest uppercase mb-8">pro Monat · jederzeit kündbar (4 Wochen)</div>
              <div className="text-[1.05rem] text-brand-text leading-relaxed">
                Board Meeting (1 Tag/Monat) + 1:1 Sparring (1h/Woche).<br/><br/>
                <strong className="text-brand-gold2 font-bold block mb-4">Garantie: Verdoppelung des Unternehmenswertes in max. 36 Monaten — tritt früher ein, umso besser.</strong>
                <span className="text-brand-muted text-[0.85rem] italic">Kündigung jederzeit mit 4 Wochen Frist möglich.</span>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}